var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        size: "lg",
        title: "Folder settings",
        centered: "",
        "no-enforce-focus": true,
      },
      on: { hide: _vm.handleCloseModal, show: _vm.fetchData },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "ButtonPrimary",
                { attrs: { variant: "primary" }, on: { click: _vm.save } },
                [_vm._v("\n      Save\n    ")]
              ),
              _vm._v(" "),
              _c(
                "ButtonOutline",
                {
                  attrs: { variant: "outline-primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs.modal.hide()
                    },
                  },
                },
                [_vm._v("\n      Cancel\n    ")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm.isLoading
        ? _c(
            "div",
            {
              staticClass: "justify-content-center align-items-center loading",
              staticStyle: {
                position: "absolute",
                top: "0",
                left: "0",
                bottom: "0",
                right: "0",
                background: "#ffffffb0",
                "z-index": "999",
                display: "flex",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "spinner-border text-primary",
                  attrs: { role: "status" },
                },
                [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._v(" "),
      _c("b-alert", { attrs: { show: "", variant: "info" } }, [
        _vm._v(
          "\n    Please note, if none selected - all company members have access to this " +
            _vm._s(_vm.selectedItems[0]?.type ?? "") +
            ".\n  "
        ),
      ]),
      _vm._v(" "),
      _c("h3", [
        _c("b", [_vm._v("User groups")]),
        _vm._v(" who have access to the folder"),
      ]),
      _vm._v(" "),
      _c("InputTags", {
        attrs: {
          items: _vm.userGroupsOptions,
          "selected-items": _vm.userGroupsSelected,
          placeholder: "Select groups",
        },
        on: { itemsChanged: _vm.handleGroupsChange },
      }),
      _vm._v(" "),
      _c("h3", [
        _c("b", [_vm._v("Users")]),
        _vm._v(" who have access to the folder"),
      ]),
      _vm._v(" "),
      _c("InputTags", {
        attrs: {
          items: _vm.userOptions,
          "selected-items": _vm.usersSelected,
          placeholder: "Select users",
        },
        on: { itemsChanged: _vm.handleUsersChange },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }